import { OhsUser } from 'user/OhsUser';
import { ModuleUrl, ModuleRoute } from 'global-services/constants/OhsRoutes';
import { getMyHubAccess } from 'admin2/my-hub/utils/OhsMyHubUtils';

export const getAdminMyHubPermission = (user: OhsUser | undefined) => {
  return getMyHubAccess(user).hasMyHubPermission;
};
const commonPermission = (user: OhsUser) => user?.configs?.admin2?.PERMISSIONS.view || false;
const createRoute = (path: string, permission: (user: OhsUser) => boolean) => ({
  path,
  url: `/${ModuleUrl.Admin2}/${path}`,
  permission,
});

const OhsAdmin2RouteList = {
  [ModuleRoute.Settings]: createRoute('user-settings', commonPermission),
  [ModuleRoute.MyHub]: createRoute('my-hub', getAdminMyHubPermission),
  [ModuleRoute.ImportManager]: createRoute('import', commonPermission),
  [ModuleRoute.Xsi]: createRoute('xsi/:orgId', commonPermission),
  [ModuleRoute.Ada]: createRoute('ada/*', commonPermission),
  [ModuleRoute.UserActivity]: createRoute('useractivity', commonPermission),
};

export default OhsAdmin2RouteList;
